// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Fark","title":"styles_title__31Cxj"};